class HalloweenVehicleFinder extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.fields = ['vehicle', 'year', 'brand', 'model', 'series'];
    this.selects = this.fields.map(key => this.querySelector('[data-field="' + key + '"]'));
    this.text = JSON.parse(this.querySelector('.hf-translations').textContent);
    this.status = this.querySelector('.hf-status');
    this.form = this.querySelector('form');
    this.results = this.querySelector('.hf-results');
    this.nativeGrid = document.querySelector('.section-main-collection-product-grid');
    this.params = { vehicle: 'hf_vehicle', year: 'hf_year', brand: 'hf_brand', model: 'hf_model', series: 'hf_series' };
    this.page = 1;
    this.token = 0;
    this.selects.forEach((select, index) => select.addEventListener('change', () => {
      this.token++;
      this.setBusy(false);
      this.results.hidden = true;
      if (this.nativeGrid) this.nativeGrid.hidden = false;
      for (let next = index + 1; next < this.selects.length; next++) this.selects[next].value = '';
      this.populate();
      this.status.textContent = this.text.pending;
    }));
    this.form.addEventListener('submit', event => { event.preventDefault(); this.search(true); });
    this.querySelector('.hf-clear').addEventListener('click', event => { event.preventDefault(); this.clear(); });
    this.querySelector('.hf-sort').addEventListener('change', () => { this.page = 1; this.render(); this.writeUrl(); });
    this.querySelector('.hf-previous').addEventListener('click', () => this.changePage(-1));
    this.querySelector('.hf-next').addEventListener('click', () => this.changePage(1));
    this.onPop = () => this.restore();
    window.addEventListener('popstate', this.onPop);
    this.loadMapping();
  }
  disconnectedCallback() { window.removeEventListener('popstate', this.onPop); }
  async loadMapping() {
    if (this.mappingPromise) return this.mappingPromise;
    this.querySelector('.hf-search').disabled = true;
    this.mappingPromise = (async () => {
      try {
        const response = await fetch(this.dataset.source, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('mapping');
        const data = await response.json();
        if (data.collectionId !== '502809755894' || !Array.isArray(data.rows)) throw new Error('scope');
        this.rows = data.rows;
        this.querySelector('.hf-search').disabled = false;
        await this.restore();
      } catch (error) {
        this.status.textContent = this.text.error;
        this.querySelector('.hf-search').disabled = false;
      }
    })();
    try { return await this.mappingPromise; }
    finally { this.mappingPromise = null; }
  }
  values() { return Object.fromEntries(this.fields.map((key, i) => [key, this.selects[i].value])); }
  matching(values, through = 4) {
    return this.rows.filter(row => this.fields.every((key, index) => index > through || !values[key] || (key === 'year' ? Number(values[key]) >= row.start && Number(values[key]) <= row.end : values[key] === row[key])));
  }
  populate() {
    const values = this.values();
    this.selects.forEach((select, index) => {
      const value = values[this.fields[index]];
      const enabled = index === 0 || this.selects.slice(0, index).every(item => item.value);
      const options = new Set();
      if (enabled) this.matching(values, index - 1).forEach(row => {
        if (index === 1) { for (let year = row.start; year <= row.end; year++) options.add(String(year)); }
        else options.add(row[this.fields[index]]);
      });
      const sorted = [...options].sort(index === 1 ? (a,b) => Number(b) - Number(a) : (a,b) => a.localeCompare(b, this.dataset.locale));
      select.replaceChildren(new Option(this.text.choose, ''), ...sorted.map(option => new Option(option, option)));
      select.disabled = !enabled;
      select.value = options.has(value) ? value : '';
      values[this.fields[index]] = select.value;
    });
  }
  async catalog() {
    if (this.catalogPromise) return this.catalogPromise;
    this.catalogPromise = (async () => {
      let products = [], pages = 1, total = null;
      const locationUrl = new URL(location.href);
      for (let page = 1; page <= pages; page++) {
        const url = new URL(this.dataset.collection, location.origin);
        url.searchParams.set('view', 'halloween-catalog');
        url.searchParams.set('page', String(page));
        for (const key of ['preview_theme_id', '_fd', 'pb']) if (locationUrl.searchParams.has(key)) url.searchParams.set(key, locationUrl.searchParams.get(key));
        const response = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('catalog');
        const data = await response.json();
        if (String(data.collectionId) !== '502809755894' || !Array.isArray(data.products) || data.page !== page || data.pages > 40) throw new Error('scope');
        if (total !== null && total !== data.total) throw new Error('changed');
        total = data.total;
        pages = data.pages;
        products.push(...data.products);
      }
      products = [...new Map(products.map(product => [String(product.id), product])).values()];
      if (products.length !== total) throw new Error('incomplete');
      this.products = products;
      return products;
    })();
    try { return await this.catalogPromise; }
    finally { this.catalogPromise = null; }
  }
  async search(updateUrl, desiredPage = 1) {
    if (!this.rows) { await this.loadMapping(); if (!this.rows) return; }
    const values = this.values();
    if (Object.values(values).some(value => !value)) { this.status.textContent = this.text.incomplete; this.form.reportValidity(); return; }
    const token = ++this.token;
    this.status.textContent = this.text.loading;
    this.setBusy(true);
    try {
      const products = await this.catalog();
      if (token !== this.token) return;
      const rows = this.matching(values);
      this.ambiguous = new Set(rows.map(row => row.collection.toLowerCase())).size > 1;
      const ids = new Set(rows.flatMap(row => row.ids));
      this.matches = this.ambiguous ? [] : products.filter(product => ids.has(String(product.id)));
      this.applied = { ...values };
      this.page = desiredPage;
      this.results.hidden = false;
      if (this.nativeGrid) this.nativeGrid.hidden = true;
      this.render();
      this.status.textContent = this.ambiguous ? this.text.ambiguous : this.matches.length + ' ' + this.text.results;
      if (updateUrl) this.writeUrl();
    } catch (error) {
      if (token !== this.token) return;
      this.status.textContent = this.text.error;
      this.results.hidden = true;
      if (this.nativeGrid) this.nativeGrid.hidden = false;
    } finally { if (token === this.token) this.setBusy(false); }
  }
  setBusy(value) { this.form.setAttribute('aria-busy', String(value)); this.querySelector('.hf-search').disabled = value; }
  render() {
    if (!this.matches) return;
    const sort = this.querySelector('.hf-sort').value;
    const products = [...this.matches].sort(sort === 'low' ? (a,b) => a.price-b.price : sort === 'high' ? (a,b) => b.price-a.price : (a,b) => a.title.localeCompare(b.title, this.dataset.locale));
    const pages = Math.max(1, Math.ceil(products.length / 24));
    this.page = Math.max(1, Math.min(pages, Number.isFinite(this.page) ? Math.floor(this.page) : 1));
    this.querySelector('.hf-count').textContent = products.length + ' ' + this.text.results;
    const message = this.querySelector('.hf-message');
    message.hidden = products.length > 0;
    message.textContent = this.ambiguous ? this.text.ambiguous : this.text.empty;
    this.querySelector('.hf-contact').hidden = !this.ambiguous;
    this.querySelector('.hf-sort-label').hidden = products.length === 0;
    const grid = this.querySelector('.hf-grid');
    grid.replaceChildren(...products.slice((this.page-1)*24, this.page*24).map(product => this.card(product)));
    this.querySelector('.hf-pagination').hidden = pages < 2;
    this.querySelector('.hf-previous').disabled = this.page === 1;
    this.querySelector('.hf-next').disabled = this.page === pages;
    this.querySelector('.hf-page').textContent = this.text.page + ' ' + this.page + ' ' + this.text.of + ' ' + pages;
  }
  card(product) {
    const item = document.createElement('li'); item.className = 'hf-card';
    const link = document.createElement('a');
    const url = new URL(product.url, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return item;
    const current = new URL(location.href);
    if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
    link.href = url.pathname + url.search;
    if (product.image) {
      const image = document.createElement('img'); image.src = product.image; image.alt = product.alt || product.title; image.width = 600; image.height = 600; image.loading = 'lazy'; image.decoding = 'async'; link.append(image);
    }
    const body = document.createElement('div'); body.className = 'hf-card-body';
    const title = document.createElement('h4'); title.textContent = product.title;
    const price = document.createElement('p'); price.className = 'hf-card-price'; price.textContent = (product.varies ? this.text.from + ' ' : '') + product.money;
    const action = document.createElement('span'); action.className = 'hf-card-action'; action.textContent = this.text.view;
    body.append(title, price, action); link.append(body); item.append(link); return item;
  }
  writeUrl() {
    const url = new URL(location.href);
    for (const [field, key] of Object.entries(this.params)) { if (this.applied?.[field]) url.searchParams.set(key, this.applied[field]); else url.searchParams.delete(key); }
    url.searchParams.delete('page');
    if (this.applied) { url.searchParams.set('hf_page', String(this.page)); url.searchParams.set('hf_sort', this.querySelector('.hf-sort').value); }
    else { url.searchParams.delete('hf_page'); url.searchParams.delete('hf_sort'); }
    history.replaceState({ ...history.state, searchParams: new URL(location.href).searchParams.toString() }, '', location.href);
    history.pushState({ searchParams: url.searchParams.toString() }, '', url.pathname + url.search);
  }
  async restore() {
    if (!this.rows) return;
    const url = new URL(location.href);
    const values = this.fields.map(field => url.searchParams.get(this.params[field]) || '');
    this.selects.forEach(select => { select.value = ''; });
    this.populate();
    this.selects.forEach((select, index) => { select.value = values[index]; this.populate(); });
    this.querySelector('.hf-sort').value = ['az','low','high'].includes(url.searchParams.get('hf_sort')) ? url.searchParams.get('hf_sort') : 'az';
    if (values.every(Boolean) && this.selects.every(select => select.value)) await this.search(false, Number(url.searchParams.get('hf_page')) || 1);
    else { this.token++; this.results.hidden = true; this.applied = null; if (this.nativeGrid) this.nativeGrid.hidden = false; this.status.textContent = ''; this.setBusy(false); }
  }
  clear() {
    this.token++;
    const url = new URL(this.dataset.collection, location.origin);
    const current = new URL(location.href);
    for (const key of ['preview_theme_id', '_fd', 'pb']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    location.assign(url.pathname + url.search);
  }
  changePage(direction) { this.page += direction; this.render(); this.writeUrl(); this.querySelector('.hf-count').focus(); }
}
if (!customElements.get('halloween-vehicle-finder')) customElements.define('halloween-vehicle-finder', HalloweenVehicleFinder);
